import React, { createContext, useContext, useMemo } from 'react';
import { stripUndefinedValues } from '../../helpers/utils';
const ConfigContext = createContext({});
export const useAsyncData = () => useContext(ConfigContext);
export default ({ children, handlers }) => {
    const value = useMemo(() => stripUndefinedValues(handlers), [handlers]);
    return React.createElement(ConfigContext.Provider, { value: value }, children);
};
//# sourceMappingURL=DataFetchingProvider.js.map